export const updateState = () => ({
  type: 'UPDATE_STATE',
});

export const resetState = () => ({
  type: 'RESET_STATE',
});

export const updateAccessStatus = data => ({
  type: 'UPDATE_ACCESS_STATUS',
  data
});

export const updateLayouts = data => ({
  type: 'UPDATE_LAYOUTS',
  data
});

export const updateProjectsStatus = data => ({
  type: 'UPDATE_PROJECTS_STATUS',
  data
});

export const updateActualLayout = data => ({
  type: 'UPDATE_ACTUAL_LAYOUT',
  data
});

export const updateSending = data => ({
  type: 'UPDATE_SENDING',
  data
});

export const updateProjects = data => ({
  type: 'UPDATE_PROJECTS',
  data
});

export const updateInitApp = data => ({
  type: 'UPDATE_INIT_APP',
  data
});

export const showNotify = data => ({
  type: 'SHOW_NOTIFY',
  data
});

export const hideNotify = data => ({
  type: 'HIDE_NOTIFY',
  data
});